import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from '../../components/common/Button';
import styles from './styles.module.css';
import { faChevronRight, faPen } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import Box from './components/Box';
import { useGetCurrentUserQuery } from '../../api/userApi';
import PolicyRequired from '../../components/common/PolicyRequired';
import Banners from './components/Banners';
import HeaderLayout from '../../components/HeaderLayout';

function Mypage() {
  const navigate = useNavigate();
  const { userName, email, password } = useUserInfo();

  return (
    <HeaderLayout title="マイページ">
      <div className={styles.host}>
        <Banners />
        <div className={styles.main}>
          <Box title="アカウント情報">
            <Property
              name="名前"
              value={userName}
              onEditRequest={() => navigate('change-username')}
            />
            <Property
              name="メールアドレス(ログインID)"
              value={email}
              onEditRequest={() => navigate('change-email')}
            />
            <Property
              name="パスワード"
              value={password}
              onEditRequest={() => navigate('change-password')}
            />
          </Box>
        </div>
      </div>
    </HeaderLayout>
  );
}

export default Mypage;

function Property({
  name,
  value,
  onEditRequest,
}: {
  name: string;
  value: string;
  onEditRequest?: () => void;
}) {
  return (
    <>
      <div className={styles.property}>
        <div className={styles.propertyDisplay}>
          <div className={styles.propertyName}>{name}</div>
          <div className={styles.propertyValue}>{value}</div>
        </div>
        <PolicyRequired policy={1}>
          <div className={styles.smallButtonContainer}>
            <button
              type="button"
              className={styles.smallButton}
              onClick={onEditRequest}
            >
              <FontAwesomeIcon icon={faChevronRight} />
            </button>
          </div>
          <div className={styles.bigButtonContainer}>
            <Button
              variants={['secondary']}
              type="button"
              onClick={onEditRequest}
            >
              <FontAwesomeIcon icon={faPen} className={styles.penIcon} />
              <span>編集</span>
            </Button>
          </div>
        </PolicyRequired>
      </div>
      <hr className={styles.border} />
    </>
  );
}

function useUserInfo() {
  const { data } = useGetCurrentUserQuery();
  return {
    userName: data?.userName ?? '',
    email: data?.email ?? '',
    password: data ? '※セキュリティのため非表示' : '',
  };
}
